// extracted by mini-css-extract-plugin
export default {"root":"EmptyStub_root__c11VA","image":"EmptyStub_image__9Ux7r","text":"EmptyStub_text__VMU1P","placeHolderShimmer":"EmptyStub_placeHolderShimmer__35vRk"};